(function () {
  const popup = document.getElementById("gdpr-popup");
  const acknowledgeBtn = document.getElementById("acknowledge-btn");

  if (popup && acknowledgeBtn) {
    if (localStorage.getItem("gdpr-acknowledged") !== "true") {
      popup.style.display = "block";
    }

    acknowledgeBtn.addEventListener("click", function () {
      popup.style.display = "none";

      localStorage.setItem("gdpr-acknowledged", "true");
    });
  }
})();